export type ABTestId = 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g' | 'h' | 'i'

export interface ABTestContent {
  componentId: string
  message: string
}

export const AB_TEST_VARIANTS: Record<ABTestId, ABTestContent> = {
  a: {
    componentId: '20250311_A',
    message: '이동지원금 챙기셨어요? 바로 받을 수 있는 69,900원 꼭 가져가세요.',
  },
  b: {
    componentId: '20250311_B',
    message: '이동지원금 소진임박! 69,900원 지금 빨리 받아가세요!',
  },
  c: {
    componentId: '20250311_C',
    message:
      '이제 BMW M5 응모할 수 있어요! 69,900원도 받고, 응모까지 한번에 하세요!',
  },
  d: {
    componentId: '20250317_A',
    message: '이동지원금 챙기셨어요? 바로 받을 수 있는 69,900원 꼭 가져가세요.',
  },
  e: {
    componentId: '20250317_B',
    message: '이동지원금 혜택 도착!🎁 한 번 터치하고 69,900원 혜택받으러 가기',
  },
  f: {
    componentId: '20250317_C',
    message: '지금 바로 69,900원 혜택받고 1만 크레딧까지 무한대로 받기!',
  },
  g: {
    componentId: '20250320_G',
    message: '이동지원금 혜택 도착!🎁 한 번 터치하고 69,900원 혜택받으러 가기',
  },
  h: {
    componentId: '20250320_H',
    message: '누적 지급액 20억 돌파!🎉 소진 전 69,900원 받기!',
  },
  i: {
    componentId: '20250320_I',
    message: '전국민 이동지원금 69,900원🪙나도 받으러 가기!',
  },
} as const
